import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-sla-state"]
const _hoisted_2 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_3 = { class: "text-xs font-bold text-[#52526F]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "text-md font-bold text-textPrimary" }, "Solicitação de Registro de Atividade", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "rounded-full bg-lightGray30 px-2 py-0.5 text-[10px] font-bold text-neutral50" }, " Aguardando envio ", -1)
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = {
  key: 0,
  class: "mt-2 rounded-md border border-alert bg-[#FDF1DF] px-3 py-2 text-xs text-textPrimary",
  "data-testid": "activity-request-reopen"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "mt-3 grid grid-cols-1 gap-4 text-sm md:grid-cols-4" }
const _hoisted_10 = { "data-testid": "activity-request-col-station" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-1 text-xs font-bold uppercase text-neutral50" }, "Plantão", -1)
const _hoisted_12 = { class: "m-0" }
const _hoisted_13 = { class: "m-0" }
const _hoisted_14 = {
  key: 0,
  class: "m-0 text-neutral50"
}
const _hoisted_15 = { class: "m-0 text-neutral50" }
const _hoisted_16 = { class: "m-0 text-neutral50" }
const _hoisted_17 = { "data-testid": "activity-request-col-doctor" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-1 text-xs font-bold uppercase text-neutral50" }, "Médico", -1)
const _hoisted_19 = { class: "m-0 font-bold" }
const _hoisted_20 = { class: "m-0 text-neutral50" }
const _hoisted_21 = { "data-testid": "activity-request-col-expected" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-1 text-xs font-bold uppercase text-neutral50" }, "Registro esperado", -1)
const _hoisted_23 = { class: "m-0" }
const _hoisted_24 = { class: "m-0" }
const _hoisted_25 = { class: "m-0" }
const _hoisted_26 = { class: "m-0" }
const _hoisted_27 = { class: "block text-[11px] text-neutral50" }
const _hoisted_28 = { "data-testid": "activity-request-col-situation" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-1 text-xs font-bold uppercase text-neutral50" }, "Situação", -1)
const _hoisted_30 = ["data-testid", "data-missing"]
const _hoisted_31 = {
  key: 0,
  class: "m-0 text-xs text-neutral50"
}
const _hoisted_32 = {
  key: 1,
  class: "m-0 text-xs",
  "data-testid": "activity-request-value"
}
const _hoisted_33 = { class: "mt-3 flex flex-wrap items-center gap-2 border-t border-lightGray30 pt-2" }
const _hoisted_34 = {
  class: "m-0 text-xs text-neutral50",
  "data-testid": "activity-request-footer"
}
const _hoisted_35 = { class: "ml-auto flex gap-2" }
const _hoisted_36 = { "data-testid": "activity-request-details-button" }
const _hoisted_37 = { "data-testid": "activity-request-send-record-button" }

import { computed } from 'vue'

import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { QUEUE_TONE_PILL_CLASS } from '@/components/designSystem/QueueViews/types'
import type { QueueTone } from '@/components/designSystem/QueueViews/types'
import {
  EFFECTIVE_SOURCE_KIND_LABELS,
  REQUESTED_LEG_LABELS
} from '@/constants/ds-attendance.constants'
import type { EffectiveSourceKind } from '@/constants/ds-attendance.constants'
import type { ActivityRequestItem } from '@/types/activity-requests.types'
import { DEFAULT_UTC_OFFSET, formatDayMonthInOffset, formatHourMinuteInOffset } from '@/utils/date'

import {
  formatBRL,
  formatDateTimeInStation,
  formatDeadlineRelative,
  formatLegDeviation,
  formatStationPeriod,
  openingRuleLabel,
  registrationModeLabel,
  sendWindowLabel,
  slaTone,
  timezoneLabel
} from '../../utils/activity-request-format'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityRequestCard',
  props: {
    item: {},
    nowMs: {}
  },
  emits: ["details", "sendRecord"],
  setup(__props: any, { emit }) {

const props = __props;





const CARD_CLASS: Record<QueueTone, string> = {
  crit: 'border-negative bg-red-50',
  warn: 'border-alert bg-orange-50',
  ok: 'border-lightGray30 bg-white',
  info: 'border-lightGray30 bg-white',
  neutral: 'border-lightGray30 bg-white'
}

const CHIP_CLASS: Record<QueueTone, string> = {
  crit: 'bg-red-600 text-white',
  warn: 'bg-orange-500 text-white',
  ok: 'bg-green-600 text-white',
  info: 'bg-blue-600 text-white',
  neutral: 'bg-lightGray30 text-neutral50'
}

const STATE_FALLBACK: Record<string, string> = {
  OVERDUE: 'Vencida',
  ATTENTION: 'Vence em 24 h',
  URGENT: 'Vence em 24 h',
  ON_TIME: 'No prazo'
}

const payload = computed(() => props.item.payload)
const offset = computed(
  () => props.item.timezone || payload.value.station.timezone || DEFAULT_UTC_OFFSET
)
const tone = computed(() => slaTone(props.item.sla?.state))

const deadlineIso = computed(
  () => payload.value.sendDeadlineAt ?? props.item.sla?.deadlineAt ?? null
)

const deadlineChipText = computed(
  () =>
    formatDeadlineRelative(deadlineIso.value, props.nowMs) ??
    STATE_FALLBACK[props.item.sla?.state ?? ''] ??
    'Sem prazo'
)

const deadlineAbsolute = computed(() => formatDateTimeInStation(deadlineIso.value, offset.value))
const zoneLabel = computed(() => timezoneLabel(offset.value))

const period = computed(() =>
  formatStationPeriod(payload.value.station.startAt, payload.value.station.endAt, offset.value)
)
const shiftName = computed(() => props.item.location.shiftName ?? payload.value.station.shiftName)

const legLabel = computed(
  () => REQUESTED_LEG_LABELS[payload.value.requestedLeg] ?? payload.value.requestedLeg
)

const modeLabel = computed(() =>
  registrationModeLabel(payload.value.registrationMode ?? payload.value.requestChannel)
)

const ruleText = computed(() => {
  const window = sendWindowLabel(payload.value.sendWindowHours)
  const rule = openingRuleLabel(payload.value.openingRule)
  return window ? `${rule} · janela de ${window}` : rule
})

const sourceLabel = (source: string | null): string =>
  source
    ? (EFFECTIVE_SOURCE_KIND_LABELS[source as EffectiveSourceKind] ?? source)
    : 'fonte não informada'

const legRows = computed(() =>
  (
    [
      { key: 'checkin', label: 'Entrada', expected: payload.value.station.startAt },
      { key: 'checkout', label: 'Saída', expected: payload.value.station.endAt }
    ] as const
  ).map((leg) => {
    const effective = payload.value.effectiveSummary?.[leg.key] ?? null
    const expectedTime = leg.expected
      ? (formatHourMinuteInOffset(leg.expected, offset.value) ?? '--:--')
      : '--:--'
    if (!effective?.value) {
      return { key: leg.key, missing: true, text: `${leg.label} pendente · prev. ${expectedTime}` }
    }
    const time = formatHourMinuteInOffset(effective.value, offset.value) ?? '--:--'
    const deviation = formatLegDeviation(effective.value, leg.expected)
    return {
      key: leg.key,
      missing: false,
      text: `${leg.label} ✓ ${time} · prev. ${expectedTime}${deviation ? ` · ${deviation}` : ''} · ${sourceLabel(effective.source)}`
    }
  })
)

/** A justificativa de quem reprovou é o texto útil; o rótulo do código é o fallback. */
const reopenReason = computed(() => {
  const reopen = payload.value.reopen
  return (
    reopen?.rejectionJustification ??
    reopen?.rejectionReasonLabel ??
    reopen?.rejectionReason ??
    null
  )
})

const reopenText = computed(() => {
  const reopen = payload.value.reopen
  if (!reopen) return ''
  const submitted = reopen.previousSubmittedByName
    ? ` (enviado por ${reopen.previousSubmittedByName}${
        reopen.previousSubmittedAt
          ? ` em ${formatDayMonthInOffset(reopen.previousSubmittedAt, offset.value) ?? ''}`
          : ''
      })`
    : ''
  const rejected = reopen.rejectedByName
    ? ` · reprovado por ${reopen.rejectedByName}${
        reopen.rejectedAt
          ? ` em ${formatDayMonthInOffset(reopen.rejectedAt, offset.value) ?? ''}`
          : ''
      }`
    : ''
  return `Reaberta após rejeição do #${reopen.previousContainerId}${submitted}${rejected}`
})

const openedAtText = computed(
  () =>
    formatDateTimeInStation(payload.value.openedAt ?? props.item.occurredAt, offset.value) ??
    'data não informada'
)
const originText = computed(() =>
  payload.value.openingRule === 'REJECTION_REOPEN' ? 'reaberta · rejeição' : 'automática · política'
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["mb-4 rounded-lg border p-4", CARD_CLASS[tone.value]]),
    "data-testid": "activity-request-card",
    "data-sla-state": _ctx.item.sla?.state ?? 'UNKNOWN'
  }, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "#" + _toDisplayString(_ctx.item.entityId), 1),
      _hoisted_4,
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.badges, (badge) => {
        return (_openBlock(), _createElementBlock("span", {
          key: badge.key,
          class: _normalizeClass(["rounded-full px-2 py-0.5 text-[11px]", [
          _unref(QUEUE_TONE_PILL_CLASS)[badge.tone],
          badge.tone === 'crit' ? 'font-bold ring-1 ring-red-300' : ''
        ]]),
          "data-testid": `activity-request-badge-${badge.key}`
        }, _toDisplayString(badge.label), 11, _hoisted_6))
      }), 128)),
      _createElementVNode("span", {
        class: _normalizeClass(["ml-auto rounded-md px-2.5 py-1 text-xs font-bold", CHIP_CLASS[tone.value]]),
        "data-testid": "activity-request-deadline-chip"
      }, _toDisplayString(deadlineChipText.value), 3)
    ]),
    (payload.value.reopen)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
          _createTextVNode(_toDisplayString(reopenText.value) + " ", 1),
          (reopenReason.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_8,
                _createTextVNode("Motivo: “" + _toDisplayString(reopenReason.value) + "” ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("section", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString(period.value.weekday ? `${period.value.weekday}, ` : '') + _toDisplayString(period.value.date), 1),
        _createElementVNode("p", _hoisted_13, "Previsto " + _toDisplayString(period.value.range) + " · " + _toDisplayString(period.value.duration), 1),
        (shiftName.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Turno " + _toDisplayString(shiftName.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.item.location.healthUnitName), 1),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.item.location.scheduleName), 1)
      ]),
      _createElementVNode("section", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.item.actor?.name ?? 'Médico não informado'), 1),
        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.item.actor?.crm ?? 'CRM não informado'), 1),
        (_ctx.item.actor)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["mt-1 inline-block rounded-full px-2 py-0.5 text-[11px] font-bold", _ctx.item.actor.ourTeam ? _unref(QUEUE_TONE_PILL_CLASS).ok : _unref(QUEUE_TONE_PILL_CLASS).warn]),
              "data-testid": "activity-request-team-badge"
            }, _toDisplayString(_ctx.item.actor.ourTeam ? 'Do time' : 'Fora do time'), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("p", _hoisted_23, [
          _createTextVNode(" Perna "),
          _createElementVNode("b", null, _toDisplayString(legLabel.value), 1)
        ]),
        _createElementVNode("p", _hoisted_24, [
          _createTextVNode(" Modalidade "),
          _createElementVNode("b", null, _toDisplayString(modeLabel.value), 1)
        ]),
        _createElementVNode("p", _hoisted_25, "Regra " + _toDisplayString(ruleText.value), 1),
        _createElementVNode("p", _hoisted_26, [
          _createTextVNode(" Prazo "),
          _createElementVNode("b", null, _toDisplayString(deadlineAbsolute.value ?? 'sem prazo'), 1),
          _createElementVNode("span", _hoisted_27, _toDisplayString(zoneLabel.value), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_28, [
        _hoisted_29,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(legRows.value, (leg) => {
          return (_openBlock(), _createElementBlock("p", {
            key: leg.key,
            class: _normalizeClass(["m-0 mb-1 rounded px-2 py-0.5", 
            leg.missing ? 'border border-dashed border-negative text-negative' : 'text-textPrimary'
          ]),
            "data-testid": `activity-request-leg-${leg.key}`,
            "data-missing": String(leg.missing)
          }, _toDisplayString(leg.text), 11, _hoisted_30))
        }), 128)),
        (payload.value.payment.hasAntecipe || payload.value.payment.hasInCash)
          ? (_openBlock(), _createElementBlock("p", _hoisted_31, " Pagamento prioritário retido até o registro de: " + _toDisplayString(legLabel.value) + ". ", 1))
          : _createCommentVNode("", true),
        (_ctx.item.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
              _createTextVNode(" Valor a pagar (Financeiro) "),
              _createElementVNode("b", null, _toDisplayString(_unref(formatBRL)(_ctx.item.value.amount)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("footer", _hoisted_33, [
      _createElementVNode("p", _hoisted_34, " Aberta em " + _toDisplayString(openedAtText.value) + " (" + _toDisplayString(originText.value) + ") · cancela sozinha se o que falta (" + _toDisplayString(legLabel.value) + ") for coberto por folha aprovada, check tardio, App vizinho ou permanência. ", 1),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(OutlinedButton, {
            text: "Ver detalhes",
            width: "130px",
            height: "32px",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('details', _ctx.item.entityId)))
          })
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(OutlinedButton, {
            text: "Enviar registro",
            width: "150px",
            height: "32px",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('sendRecord', _ctx.item.entityId)))
          })
        ])
      ])
    ])
  ], 10, _hoisted_1))
}
}

})